import { toast } from "react-hot-toast";

const CustomToast = ({ message, t, type }) => {
  const handleClose = () => {
    toast.remove(t.id);
  };

  return (
    <div
      className={`custom-toast flex flex-row-reverse  justify-between gap-3 w-full sm:w-fit min-w-[280px] sm:max-w-[25rem] p-4 ${
        type === "error"
          ? "bg-[#ff6b6b] border-[#ff4d4d]"
          : "bg-[#68af6b] border-[#46a349]"
      } text-white border rounded-lg font-[Pingar LT, sans-serif] text-sm`}
    >
      <button
        onClick={handleClose}
        className="cursor-pointer hover:opacity-80 transition-opacity order-1 sm:order-2  sm:self-auto"
      >
        <img
          src="/images/cross.svg"
          alt="Close"
          className="min-w-4 min-h-4 max-w-4 max-h-4"
        />
      </button>
      <div className="flex flex-row justify-end items-start sm:items-center gap-2 sm:gap-4">
        <div className="flex items-center gap-3 order-2 sm:order-1">
          <span className="text-[15px]">{message}</span>
          <img src="/images/alert.svg" alt="Alert" className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
